import { useDispatch, useSelector } from "react-redux";
import { _ } from "src/services";
import { MessageModalState, MessageModalsAction, Modals } from "src/store";
import { Modal } from "./modal";

export const MessageModal: React.FC = () => {

    //#region dependencies

    const dispatch = useDispatch();
    const modals: Modals = useSelector((state: any) => state.ModalsState);
    const message: MessageModalState = useSelector((state: any) => state.MessageModalsState);

    //#endregion

    //region methods

    const onClose = () => {
        dispatch(MessageModalsAction.hideMessage());

    };

    //#endregion

    //#region helpers

    const renderFooter = () => {
        return (
            <>
                <div className="col-8 offset-2">
                    <button onClick={onClose} className="w-100 btn focusable btn-submit">{_("messageModalButton")}</button>
                </div>
            </>
        );
    };


    const logoFile = message.icon ? require(`src/assets/static/img/main/${message.icon}`) : undefined;

    const renderBody = () => {
        return (
            <div className="content text-center">
                {logoFile && <img src={logoFile.default} alt="" />}
                {message.title && <h1 className="rtl">{message.title}</h1>}
                {message.message && <p className="rtl">{message.message}</p>}
            </div>
        );
    };

    //#endregion

    return (
        <Modal show={modals.message} onClose={onClose} renderFooter={renderFooter} className="modal-component--message">
            <div className="content text-center">
                {renderBody()}
            </div>
        </Modal>
    );

};